/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Support_Content_PlaceholderInputs */

const en_common_support_content_placeholder = /** @type {(inputs: Common_Support_Content_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your issue in detail...`)
};

const zh_common_support_content_placeholder = /** @type {(inputs: Common_Support_Content_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`详细描述你遇到的问题…`)
};

/**
* | output |
* | --- |
* | "Describe your issue in detail..." |
*
* @param {Common_Support_Content_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_support_content_placeholder = /** @type {((inputs?: Common_Support_Content_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Support_Content_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_support_content_placeholder(inputs)
	return zh_common_support_content_placeholder(inputs)
});
export { common_support_content_placeholder as "common.support.content_placeholder" }